var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "reports pa-0", attrs: { "fill-height": "", fluid: "" } },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-title",
            { staticClass: "body-2 d-block px-3 pb-0" },
            [
              _c("span", { staticClass: "body-2 font-weight-medium" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$tc("labels.report", 1)) +
                    "\n      "
                )
              ]),
              _c(
                "v-btn",
                {
                  staticClass: "float-right mt-n1",
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("\n          fal fa-times\n        ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-tabs",
            {
              staticClass: "px-3",
              attrs: {
                "mobile-breakpoint": "",
                "show-arrows": false,
                "slider-color": "accent",
                "slider-size": "3"
              },
              model: {
                value: _vm.selectedTab,
                callback: function($$v) {
                  _vm.selectedTab = $$v
                },
                expression: "selectedTab"
              }
            },
            [
              _c("v-tab", { staticClass: "px-6", attrs: { href: "#shifts" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("labels.shifts")) + "\n      "
                )
              ]),
              _c("v-tab", { staticClass: "px-6", attrs: { href: "#events" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$tc("labels.event", 2)) + "\n      "
                )
              ]),
              _c(
                "v-tab",
                { staticClass: "px-6", attrs: { href: "#staffing" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("labels.staffing")) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "v-tab",
                { staticClass: "px-6", attrs: { href: "#productivity" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("labels.productivity")) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "v-tab",
                { staticClass: "px-6", attrs: { href: "#requests" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$tc("labels.request", 2)) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "v-tab",
                { staticClass: "px-6", attrs: { href: "#open-shifts" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$tc("labels.openShift", 2)) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.selectedTab,
                callback: function($$v) {
                  _vm.selectedTab = $$v
                },
                expression: "selectedTab"
              }
            },
            [
              _c(
                "v-tab-item",
                {
                  attrs: {
                    "reverse-transition": false,
                    transition: false,
                    value: "shifts"
                  }
                },
                [
                  _c("ShiftReport", {
                    attrs: {
                      "content-height": _vm.contentHeight,
                      "show-close-button": _vm.showCloseButton,
                      "show-title": false
                    },
                    on: {
                      close: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-tab-item",
                {
                  attrs: {
                    "reverse-transition": false,
                    transition: false,
                    value: "events"
                  }
                },
                [
                  _c("EventReport", {
                    attrs: {
                      "content-height": _vm.contentHeight,
                      "show-close-button": _vm.showCloseButton,
                      "show-title": false
                    },
                    on: {
                      close: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-tab-item",
                {
                  attrs: {
                    "reverse-transition": false,
                    transition: false,
                    value: "staffing"
                  }
                },
                [
                  _c("StaffingDashboard", {
                    attrs: { "content-height": _vm.contentHeight }
                  })
                ],
                1
              ),
              _c(
                "v-tab-item",
                {
                  attrs: {
                    "reverse-transition": false,
                    transition: false,
                    value: "productivity"
                  }
                },
                [
                  _c("ProductivityDashboard", {
                    attrs: { "content-height": _vm.contentHeight }
                  })
                ],
                1
              ),
              _c(
                "v-tab-item",
                {
                  attrs: {
                    "reverse-transition": false,
                    transition: false,
                    value: "requests"
                  }
                },
                [
                  _c("RequestsDashboard", {
                    attrs: { "content-height": _vm.contentHeight }
                  })
                ],
                1
              ),
              _c(
                "v-tab-item",
                {
                  attrs: {
                    "reverse-transition": false,
                    transition: false,
                    value: "open-shifts"
                  }
                },
                [
                  _c("OpenShiftsDashboard", {
                    attrs: { "content-height": _vm.contentHeight }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }